import React from 'react';

import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Typography, Link } from '@mui/material';

import { IBreadcrumbsProps } from 'src/components/common/types/breadcrumbsTypes';

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ items = [] }) => {
	return (
		<Box sx={{ py: 0, px: 0.5 }}>
			<nav className='flex flex-wrap items-center text-base tracking-normal leading-none gap-2'>
				<Link
					href='/'
					className='flex items-center gap-2'
					style={{ textDecoration: 'none', color: 'rgba(0,0,0,0.6)' }}
				>
					<HomeIcon
						sx={{ width: 17, height: 17, color: 'rgba(0,0,0,0.6)' }}
					/>
					<Typography
						variant='body1'
						sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
					>
						Home
					</Typography>
				</Link>

				{items.map((item, index) => (
					<React.Fragment key={index}>
						<Box className='flex items-center gap-1'>
							<NavigateNextIcon
								sx={{ color: 'rgba(0,0,0,0.6)' }}
							/>

							{item.href ? (
								<Link
									href={item.href}
									className='flex items-center'
									style={{
										textDecoration: 'none',
										color: 'rgba(0,0,0,0.6)',
									}}
								>
									<Typography
										variant='body1'
										sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
									>
										{item.label}
									</Typography>
								</Link>
							) : (
								<Typography
									variant='body1'
									sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
								>
									{item.label}
								</Typography>
							)}
						</Box>
					</React.Fragment>
				))}
			</nav>
		</Box>
	);
};

export default Breadcrumbs;
